import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        name: [],
        email: [],
        phone: [],
        state: [],
        country: [],
        city: [],
        active: [],
        preferences: [],
        user: [],
        category: []
    },
    selectedItems: {
        name: [],
        state: [],
        country: [],
        city: [],
        active: [],
        preferences: [],
        user: [],
        category: []
    }
};

export const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        },
        updateFilter: (state, action) => {
            const { key, values } = action.payload;
            state.filters[key] = values;
        },
        updateSelectedItems: (state, action) => {
            const { key, items } = action.payload;
            state.selectedItems[key] = items;
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        },
    },
});

export const { setFilters, updateFilter, resetFilters, updateSelectedItems } = filterSlice.actions;
export const filterReducer = filterSlice.reducer;
